import React from 'react';

import { useTranslation } from 'react-i18next';

import { CurrencyIcon } from '@pkg/components';

import { urls } from '../../ConnectWalletSheet.data';

import { Item, Link, LinkIcon, LinkText, List, StyledSupportedChains, Title } from './SupportedChains.style';

export function SupportedChains() {
    const [translate] = useTranslation('connectWallet');

    return (
        <StyledSupportedChains>
            <Title>{translate('sheet-chain-title')}</Title>

            <List>
                <Item>
                    <Link to={urls.chain.polygon} target="_blank" rel="noopener noreferrer">
                        <LinkIcon>
                            <CurrencyIcon currency="matic" />
                        </LinkIcon>

                        <LinkText>{translate('sheet-chain-polygon')}</LinkText>
                    </Link>
                </Item>
                <Item>
                    <Link to={urls.chain.aptos} target="_blank" rel="noopener noreferrer">
                        <LinkIcon>
                            <CurrencyIcon currency="apt" />
                        </LinkIcon>

                        <LinkText>{translate('sheet-chain-aptos')}</LinkText>
                    </Link>
                </Item>
                <Item>
                    <Link to={urls.chain.ethereum} target="_blank" rel="noopener noreferrer">
                        <LinkIcon>
                            <CurrencyIcon currency="eth" />
                        </LinkIcon>

                        <LinkText>{translate('sheet-chain-ethereum')}</LinkText>
                    </Link>
                </Item>
            </List>
        </StyledSupportedChains>
    );
}
